import React, { useState, useEffect } from "react";
import OTPInput from "react-otp-input";
import { Typography } from "@mui/material";

import "./verifyOtp.scss";

import { Toaster, toast } from "react-hot-toast";
import { SecondaryButton } from "../../common/Buttons";
import { useTranslation } from "react-i18next";
import { verifyOtp, resendOtp } from "../../services/user/UserServices";
import { useLocation } from "react-router-dom";
import { formatTime, getKeyFromText } from "../../utils/Utilities";

const VerifyOpt = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const { mfaTokenId: mfaToken, userId: id } = location.state;

  const [OTP, setOTP] = useState("");
  const [time, setTime] = useState(120);
  const [isLoading, setIsLoading] = useState(false);

  const [mfaTokenId, setMfaTokenId] = useState(mfaToken);
  const [userId, setUserId] = useState(id);

  useEffect(() => {
    if (time === 0) {
      return;
    }
    const interval = setInterval(() => {
      setTime((prevTime) => prevTime - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [time]);

  function handleChange(OTP) {
    setOTP(OTP);
  }
  const handleSubmit = async () => {
    if (OTP) {
      setIsLoading(true);
      const payload = {
        userId,
        mfaTokenId,
        OTP,
      };
      const result = await verifyOtp(payload);
      if (result.success) {
        window.location = "/";
      } else {
        toast.error(t(getKeyFromText(result?.message)));
        setTime(0);
      }
      setIsLoading(false);
    } else {
      toast.error(t("enter-otp"));
    }
  };
  const handleResendOtp = async () => {
    const payload = {
      userId,
      mfaTokenId,
    };
    const result = await resendOtp(payload);
    if (result.success) {
      setTime(120);
      setMfaTokenId(result?.payLoad?.mfaToken);
    }
  };
  return (
    <div className="otp-screen">
      <Toaster />
      <div className="content-container">
        <Typography
          variant="p"
          color="color.magentaDark1"
          fontWeight="bold"
          fontSize="30px"
        >
          Confirm your phone number
        </Typography>
        <div className="otpElements">
          <Typography variant="p" color="color.magentaDark1" fontSize="20px">
            Enter your verification code
          </Typography>
          <div className="otp">
            <OTPInput
              onChange={handleChange}
              value={OTP}
              inputStyle="inputStyle"
              numInputs={5}
              separator={<span> </span>}
            />
          </div>
          <SecondaryButton
            title={time === 0 ? t("resend") : formatTime(time)}
            bgColor="color.transparent"
            borderRadius="5px"
            width="120px"
            border="1px solid #dfc8db"
            hoverBgColor="color.magentaLight1"
            textTransform="initial"
            padding="0rem"
            height="2.5rem"
            position="absolute !important"
            right="0"
            top="100%"
            click={handleResendOtp}
            disabled={time === 0 ? false : true}
          />
        </div>
      </div>
      <div className="d-flex justify-content-center align-items-center submit-button-container">
        <SecondaryButton
          title={t("next")}
          bgColor="#E8D7E5"
          borderRadius="5px"
          width="200px"
          border="none"
          hoverBgColor="color.magentaLight1"
          click={handleSubmit}
          textTransform="initial"
          padding="0rem"
          height="3.2rem"
          disabled={isLoading}
        />
      </div>
    </div>
  );
};

export default VerifyOpt;
